<mat-form-field class="full-width" appearance="outline">
	<mat-label>{{ field_label }}</mat-label>
	<input type="text" #search matInput [formControl]="searchInput" [matAutocomplete]="field" appSelectOnFocus>
	<mat-autocomplete #field="matAutocomplete" (optionSelected)="selectValue($event)" [displayWith]="displayFn">
		<mat-option *ngFor="let val of filteredItems" [value]="val" >
			{{ val.categorydescription }}
		</mat-option>
	</mat-autocomplete>
</mat-form-field>
